import { memo, useRef } from "react";

// ** Custom Components
import Block from "components/layout/Block";
import FirstRightMessageLayout from "./FirstRightMessageLayout";
import FirstLeftMessageLayout from "./FirstLeftMessageLayout";
import MessageText from "./MessageText";

// ** Styled Components
import { MessageContainerWrapper } from "../styles";

import { useInView } from "react-intersection-observer";

// #####################################################

const Message = memo(
	({
		item,
		onAttachmentClick,
		onAttachmentRemove,
		chatPartner,
		isLast,
		isRightSide,
		isSeparator,
		IdLastReadedMessageInRightSide,
		IdLastVideoChatInfoInLeftSide,
		IdLastVideoChatInfoInRightSide,
		conversationUserAvatar,
		nextMinute,
		onAcceptVideoChat,
		trigger,
	}) => {
		const { ref, inView } = useInView({
			threshold: 0,
			triggerOnce: false,
			rootMargin: "0px 0px 0px 0px",
			initialInView: true,
		});

		const containerRef = useRef(null);
		const lastHeightRef = useRef(null);

		const updateHeight = () => {
			if (containerRef.current) {
				const currentHeight = containerRef.current.offsetHeight;
				if (lastHeightRef.current !== currentHeight) {
					lastHeightRef.current = currentHeight;
				}
			}
		};
		if (inView) {
			updateHeight();
		}

		const combineRef = (el) => {
			if (trigger) trigger(el);

			containerRef.current = el;
			ref(el);
		};

		return (
			!item.sending && (
				<MessageContainerWrapper
					isRightSide={isRightSide}
					isSeparator={isSeparator}
					ref={combineRef}
					style={{
						minHeight: inView
							? "auto"
							: item?.file_small || lastHeightRef.current > 0
							? lastHeightRef.current
							: "100px",
					}}
				>
					{inView && (
						<Block
							flex
							column
							alignEnd={isRightSide}
							alignStart={!isRightSide}
						>
							{isSeparator && isRightSide && (
								<FirstRightMessageLayout />
							)}
							{isSeparator && !isRightSide && (
								<FirstLeftMessageLayout user={chatPartner} />
							)}
							<MessageText
								item={item}
								onAttachmentClick={onAttachmentClick}
								onAttachmentRemove={onAttachmentRemove}
								isLast={isLast}
								isRightSide={isRightSide}
								IdLastReadedMessageInRightSide={
									IdLastReadedMessageInRightSide
								}
								IdLastVideoChatInfoInLeftSide={
									IdLastVideoChatInfoInLeftSide
								}
								IdLastVideoChatInfoInRightSide={
									IdLastVideoChatInfoInRightSide
								}
								conversationUserAvatar={conversationUserAvatar}
								nextMinute={nextMinute}
								onAcceptVideoChat={onAcceptVideoChat}
							/>
						</Block>
					)}
				</MessageContainerWrapper>
			)
		);
	}
);

// #####################################################

export default Message;
